import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { Link } from 'react-router';
import Pencil from '../svg/pencil';
import Eye from '../svg/eye';
import Document from '../svg/document';

export class InvoiceTableShowMore extends React.Component {
  static propTypes = {
    invoice: PropTypes.object.isRequired,
    invoiceRoute: PropTypes.string,
    user: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.renderEdit = this.renderEdit.bind(this);
    this.renderPdf = this.renderPdf.bind(this);
    this.renderInvoiceRoute = this.renderInvoiceRoute.bind(this);
  }

  renderEdit () {
    if (this.props.invoice.approvalStatus === 1) {
      return (<div className='table-show-more-list-item'>
        <Pencil colorSchema='primary' />
        <Link to={'/invoice-tool/' + this.props.invoice.id}>
          <Translate content='EDIT_INVOICE' />
        </Link>
      </div>);
    }
    return null;
  }

  renderPdf () {
    return this.props.invoice.pdfLink
      ? (<div className='table-show-more-list-item'>
        <Eye colorSchema='primary' />
        <a href={this.props.invoice.pdfLink} target='_blank'>
          <Translate content='PDF' />
        </a>
      </div>)
      : null;
  }

  renderInvoiceRoute () {
    return this.props.invoiceRoute
      ? (<div className='table-show-more-list-item'>
        <Document colorSchema='primary' />
        <Link to={this.props.invoiceRoute}>
          <Translate content='INVOICE_OVERVIEW' />
        </Link>
      </div>)
      : null;
  }

  render () {
    return (
      <div className='table-show-more-list'>
        {this.renderEdit()}
        {this.renderPdf()}
        {this.renderInvoiceRoute()}
      </div>
    );
  }
}

export default InvoiceTableShowMore;



/** WEBPACK FOOTER **
 ** ./src/components/show-more/show-more-invoice.js
 **/